import { atom } from 'recoil';

import { ApiResponseBasicProfile } from '../../V2/model/interfaces/MeUserData';

export const userData = atom({
  key: 'UserData',
  default: {} as unknown as ApiResponseBasicProfile
});

export const userCoreData = atom({
  key: 'UserCoreData',
  default: {} as unknown as ApiResponseBasicProfile
});

export const userLegacyData = atom({
  key: 'UserLegacyData',
  default: {} as unknown as ApiResponseBasicProfile
});
